const env = {
    // npm test === 'test'
    // npm run build === 'production'
    // npm start === 'development'
    // Quelle: https://create-react-app.dev/docs/adding-custom-environment-variables
    REACT_APP_BACKEND_SERVICE_URL: process.env.REACT_APP_BACKEND_SERVICE_URL || ''
}

export default env;


